import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnFormFieldConfig } from '../../types/form-field-config.type';

@Component({
  selector: 'sn-add-date-time-field-dialog',
  templateUrl: './add-date-time-field-dialog.component.html',
  styleUrls: ['./add-date-time-field-dialog.component.scss'],
})
export class AddDateTimeFieldDialogComponent implements OnInit {
  public form = new UntypedFormGroup({});
  public formModel: any = {};
  public formFields: SnFormFieldConfig[] = [
    {
      templateOptions: {
        label: 'Field',
      },
      wrappers: ['form-field-group'],
      fieldGroup: [
        {
          fieldGroupClassName: 'form-field-row',
          fieldGroup: [
            {
              key: 'day',
              type: 'select',
              className: 'form-field-col-12',
              templateOptions: {
                label: 'Schedule',
                multiple: false,
                required: true,
                options: [
                  { label: 'Sunday', value: 'Sun' },
                  { label: 'Monday', value: 'Mon' },
                  { label: 'Tuesday', value: 'Tue' },
                  { label: 'Wednesday', value: 'Wed' },
                  { label: 'Thursday', value: 'Thu' },
                  { label: 'Friday', value: 'Fri' },
                  { label: 'Saturday', value: 'Sat' },
                ],
              },
            },
            {
              key: 'start',
              type: 'timepicker',
              className: 'form-field-col-6',
              validators: {
                validation: ['time'],
              },
              templateOptions: {
                label: 'Start Time',
                required: true,
              },
            },
            {
              key: 'end',
              type: 'timepicker',
              className: 'form-field-col-6',
              validators: {
                validation: ['time'],
              },
              templateOptions: {
                label: 'End Time',
                required: true,
              },
            },
          ],
        },
      ],
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<AddDateTimeFieldDialogComponent>,
  ) {
    this._patchForm();
  }

  public ngOnInit(): void {}

  public cancel(): void {
    this._dialogRef.close();
  }

  public submitForm(): void {
    const startTime = this._convertToMilitaryTime(this.formModel.start);
    const endTime = this._convertToMilitaryTime(this.formModel.end);
    const data = {
      day: this.formModel.day,
      start: startTime,
      end: endTime,
    };
    this._dialogRef.close(data);
  }

  private _convertToMilitaryTime(time: string): string {
    let newTime;
    const timeArray = time.split(':');
    let hours = timeArray[0];
    if (hours.length === 1) {
      hours = '0' + hours;
    }
    const minutes = timeArray[1];
    if (time.includes('AM')) {
      const returnMins = minutes.split(' ');
      const mins = returnMins[0];
      return (newTime = hours + ':' + mins);
    }
    if (time.includes('PM')) {
      const returnMins = minutes.split(' ');
      const mins = returnMins[0];
      const militaryHours = Number(hours) + 12;
      return (newTime = militaryHours.toString() + ':' + mins);
    }
  }

  private _patchForm(): void {
    if (this.data) {
      this.formModel = this.data;
    }
  }
}
